<div class="footer-area text-center bg-white border-top-radius box-shadow">
    <p>© William Piat  by <a href="https://lemsainnovation.com/" class="fw-semibold" target="_blank">Lemsa Innovation</a>
    </p>
</div>